import React from 'react';
import './DeliveryMap.less';

const mapCenter = {lat: 50.08, lng: 19.96};
const deliveryArea = [
  {lng: 19.9546051, lat: 50.085785},
  {lng: 19.9463654, lat: 50.0738879},
  {lng: 19.9456787, lat: 50.0647427},
  {lng: 19.9431038, lat: 50.059894},
  {lng: 19.9468803, lat: 50.0583511},
  {lng: 19.9578667, lat: 50.0580205},
  {lng: 19.9697113, lat: 50.0607756},
  {lng: 19.9757195, lat: 50.059894},
  {lng: 20.0040436, lat: 50.0670567},
  {lng: 20.0031853, lat: 50.0741082},
  {lng: 19.9973488, lat: 50.0814891},
  {lng: 20.0011253, lat: 50.0876574},
  {lng: 19.9736595, lat: 50.085014},
  {lng: 19.9546051, lat: 50.085785}
];

class DeliveryMap extends React.Component {
  componentDidMount() {
    const map = new google.maps.Map(this.refs.map, {
      center: mapCenter,
      scrollwheel: false,
      zoom: 13,
      mapTypeControl: false,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_LEFT
      }
    });

    const deliveryPolygon = new google.maps.Polygon({
      paths: deliveryArea,
      strokeColor: '#dc2460',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#ff0000',
      fillOpacity: 0.1
    });

    deliveryPolygon.setMap(map);
  }

  render() {
    return (
      <section className="section section-delivery-map">
        <figure className="delivery-map" ref="map"/>
        <div className="fb-follow-container container container-limit">
          <div className="fb-follow"
            data-href="https://www.facebook.com/Stacjaborszcz"
            data-layout="standard"
            data-size="large"
            data-show-faces="true"
            width="280px"/>
        </div>
      </section>
    );
  }
}

export default DeliveryMap;



// WEBPACK FOOTER //
// ./src/components/DeliveryMap/DeliveryMap.js